<template>
  <b-modal
    id="configure-field-modal"
    ref="modal"
    :title="getModalTitle()"
    @ok="updateFieldConfiguration"
  >

    <div class="'line-chart-options-container">
      <b-form-group class="mb-3" label="Data resolution">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="dataResolution"
          :options="chartResolutionOptions"
          buttons
          name="radio-button-operation=select"
          class="'hello-world"
          size="sm"
        ></b-form-radio-group>
      </b-form-group>

      <b-form-group class="mb-3" label="Data Format">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="dataDisplayFormat"
          :options="dataDisplayOptions"
          buttons
          name="radio-button-operation=select"
          class="'hello-world"
          size="sm"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfigureField',
  props: {
    fieldDetails: null,
  },
  data() {
    return {
      chartResolutionOptions: [
        { text: 'Quarterly', value: 'Q' },
        { text: 'Quarterly (12 Months)', value: 'Q-12' },
        { text: 'Yearly', value: 'Y' },
        { text: 'Trailing 12 Months', value: 'TTM' },
      ],
      dataDisplayOptions: [
        { text: 'Absolute', value: 'A' },
        { text: 'Change (%)', value: 'C' },
      ],
      chartFormat: [

      ],
      tagClassListDisabled: 'disabled',
      dataDisplayFormat: null,
      dataResolution: null,
    };
  },
  methods: {
    updateFieldConfiguration() {
      this.$emit('configureField',
        {
          uuid: this.fieldDetails.uuid,
          fieldDetails: {
            dataResolution: this.dataResolution,
            dataDisplayFormat: this.dataDisplayFormat,
          },
        });
    },
    getModalTitle() {
      if (this.fieldDetails === null) return '';
      return this.fieldDetails.name;
    },
  },
  mounted() {
  },
};
</script>

<style>
</style>
